export const notToCheckUrls = ["login", "logout"];
